export interface SuggestedCategory {
  name: string;
  slug: string;
}

export const suggestedCategoryFromResponse = (
  responseData: any,
): SuggestedCategory => ({
  name: responseData.name,
  slug: responseData.slug,
});
